<template>
  <!-- Header -->
  <div class="header" ref="header">
    <!-- Logo -->
    <div id="toggle_btn" v-if="miniSidebar" class="header-left">
      <!-- <router-link to="/admin-dashboard" class="logo2" > -->
      <div class="logo2">
        {{ appVariant }}
        <img
          v-if="appVariant === 'default'"
          src="@/assets/img/hcmlogo2.png"
          width="60"
          height="40"
          alt="Logo"
        />
        <img
          v-else-if="appVariant === 'appedology'"
          src="@/assets/img/appedolog-color-logo.svg"
          width="60"
          height="40"
          alt="Logo"
        />
        <img
          v-else
          src="@/assets/img/proglobal-color-logo.svg"
          width="60"
          height="40"
          alt="Logo"
        />
      </div>
      <!-- </router-link> -->
    </div>
    <div id="toggle_btn" v-else class="header-left">
      <router-link class="logo" to="/employee-dashboard">
        <img
          v-if="appVariant === 'default'"
          :src="logoSrc"
          width="170"
          height="40"
          style="margin-left: 20px;"
          alt="Logo"
        />
        <img
          v-else-if="appVariant === 'appedology'"
          src="@/assets/img/appedolog-color-logo.svg"
          style="
            margin-top: -70px;
            width: 220px;
            height: 220px;
            cursor: default;
          "
          alt="Logo"
        />
        <img
          v-else
          src="@/assets/img/proglobal-color-logo.svg"
          width="60"
          height="40"
          alt="Logo"
        />
        <!-- <img src="@/assets/img/meri-sehat-logo.svg" width="170" height="40" alt="Logo" /> -->
      </router-link>
      <!-- <router-link to="/admin-dashboard" class="logo"> -->
      <!-- </router-link> -->
    </div>
    <!-- /Logo -->

    <!-- <a id="toggle_btn" href="javascript:void(0);" @click="toggleSidebar">
      <span class="bar-icon">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </a> -->

    <!-- Header Title -->
    <div class="page-title-box">
      <!-- <h3>Human Capital Management</h3> -->
    </div>
    <!-- /Header Title -->

    <a
      id="mobile_btn"
      class="mobile_btn"
      href="#sidebar"
      @click.prevent="toggleSidebar1"
      ><i class="fa-solid fa-bars"></i
    ></a>

    <!-- Header Menu -->
    <ul class="nav user-menu">
      <!-- Search -->
      <li class="nav-item gs-nav-item">
        <global-search />
      </li>
      <!-- /Search -->

      <!-- Theme Colors -->
      <li class="nav-item">
        <div class="theme-colors-section">
          <div
            v-if="isAppedologyVariant"
            class="theme-color color-organization"
            @click="changeThemeColor('#9E252E', 'rgba(158, 37, 46, 0.55)')"
          ></div>
          <div
            v-if="isProGlobalVariant"
            class="theme-color color-proglobal"
            @click="changeThemeColor('#186997', 'rgba(24,105,151,0.55)')"
          ></div>
          <div
            class="theme-color color-primary"
            @click="changeThemeColor('#FF6634', 'rgba(255, 102, 52, 0.55)')"
          ></div>
          <div
            v-if="!isAppedologyVariant"
            class="theme-color color-secondary"
            @click="
              changeThemeColor(
                clientThemeColor || '#EC048E',
                `${
                  clientThemeColor
                    ? clientThemeColor + '8c'
                    : 'rgba(236, 4, 142, 0.55)'
                }`,
              )
            "
          ></div>

          <div
            class="theme-color color-tertiary"
            @click="changeThemeColor('#008080', 'rgba(0, 128, 128, 0.55)')"
          ></div>
          <div
            v-if="!isProGlobalVariant"
            class="theme-color color-quaternary"
            @click="changeThemeColor('#01CCFF', 'rgba(1, 204, 255, 0.55)')"
          ></div>
        </div>
      </li>
      <!-- /Theme Colors -->

      <!-- Flag -->
      <li class="nav-item dropdown has-arrow flag-nav">
        <a
          class="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          href="javascript:;"
          role="button"
        >
          <img src="@/assets/img/flags/us.png" alt="Flag" height="20" />
          <span>English</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <a
            href="javascript:void(0);"
            class="dropdown-item"
            data-bs-toggle="modal"
            data-bs-target="#warning-alert-modal"
          >
            <img src="@/assets/img/flags/us.png" alt="Flag" height="16" />
            English
          </a>
          <a
            href="javascript:void(0);"
            class="dropdown-item"
            data-bs-toggle="modal"
            data-bs-target="#warning-alert-modal"
          >
            <img src="@/assets/img/flags/pk.png" alt="Flag" height="16" /> Urdu
          </a>
          <a
            href="javascript:void(0);"
            class="dropdown-item"
            data-bs-toggle="modal"
            data-bs-target="#warning-alert-modal"
          >
            <img src="@/assets/img/flags/es.png" alt="Flag" height="16" />
            Spanish
          </a>
          <!-- <a href="javascript:void(0);" class="dropdown-item">
            <img src="@/assets/img/flags/de.png" alt="Flag" height="16" /> German
          </a> -->
        </div>
      </li>
      <!-- /Flag -->

      <!-- Notifications -->
      <li class="nav-item dropdown">
        <!-- <a href="javascript:;" class="dropdown-toggle nav-link"> -->
        <a
          href="javascript:;"
          class="dropdown-toggle nav-link"
          data-bs-toggle="dropdown"
        >
          <i class="fa-solid fa-bell"></i>
          <span class="badge rounded-pill">0</span>
        </a>
        <div class="dropdown-menu notifications">
          <div class="topnav-dropdown-header">
            <span class="notification-title">Notifications</span>
            <!-- <a href="javascript:void(0)" class="clear-noti"> Clear All </a> -->
          </div>
          <div class="noti-content">
            <ul v-if="false" class="notification-list">
              <li class="notification-message">
                <router-link to="activities">
                  <div class="chat-block d-flex">
                    <span class="avatar flex-shrink-0">
                      <img
                        src="@/assets/img/profiles/avatar-03.jpg"
                        alt="User Image"
                      />
                    </span>
                    <div class="media-body flex-grow-1">
                      <p class="">
                        <strong>Tarah Shropshire</strong> changed the task name.
                        <i>Appointment booking with payment gateway </i>
                      </p>
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="activities">
                  <div class="chat-block d-flex">
                    <span class="avatar flex-shrink-0">
                      <img
                        src="@/assets/img/profiles/avatar-03.jpg"
                        alt="User Image"
                      />
                    </span>
                    <div class="media-body flex-grow-1">
                      <p class="">
                        <strong>Tarah Shropshire</strong> changed the task name.
                        <i>Appointment booking with payment gateway </i>
                      </p>
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="activities">
                  <div class="chat-block d-flex">
                    <span class="avatar flex-shrink-0">
                      <img
                        src="@/assets/img/profiles/avatar-03.jpg"
                        alt="User Image"
                      />
                    </span>
                    <div class="media-body flex-grow-1">
                      <p class="">
                        <strong>Tarah Shropshire</strong> changed the task name.
                        <i>Appointment booking with payment gateway </i>
                      </p>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
            <div
              v-else
              class="d-flex justify-content-center empty-notice-board align-items-center"
            >
              No Notifications
            </div>
          </div>
          <div class="topnav-dropdown-footer">
            <router-link to="/notifications"
              >View all Notifications</router-link
            >
          </div>
        </div>
      </li>
      <!-- /Notifications -->

      <!-- Message Notifications -->
      <!-- <li class="nav-item dropdown">
        <a href="javascript:;" class="dropdown-toggle nav-link" data-bs-toggle="dropdown">
          <i class="fa-regular fa-comment"></i> <span class="badge rounded-pill">8</span>
        </a>
        <div class="dropdown-menu notifications">
          <div class="topnav-dropdown-header">
            <span class="notification-title">Messages</span>
            <a href="javascript:void(0)" class="clear-noti"> Clear All </a>
          </div>
          <div class="noti-content">
            <ul class="notification-list">
              <li class="notification-message">
                <router-link to="chat">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img src="@/assets/img/profiles/avatar-09.jpg" alt="User Image" />
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author">Richard Miles </span>
                      <span class="message-time">12:28 AM</span>
                      <div class="clearfix"></div>
                      <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="chat">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img src="@/assets/img/profiles/avatar-02.jpg" alt="User Image" />
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author">John Doe</span>
                      <span class="message-time">6 Mar</span>
                      <div class="clearfix"></div>
                      <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="chat">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img src="@/assets/img/profiles/avatar-03.jpg" alt="User Image" />
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author"> Tarah Shropshire </span>
                      <span class="message-time">5 Mar</span>
                      <div class="clearfix"></div>
                      <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="chat">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img src="@/assets/img/profiles/avatar-05.jpg" alt="User Image" />
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author">Mike Litorus</span>
                      <span class="message-time">3 Mar</span>
                      <div class="clearfix"></div>
                      <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="chat">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img src="@/assets/img/profiles/avatar-08.jpg" alt="User Image" />
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author"> Catherine Manseau </span>
                      <span class="message-time">27 Feb</span>
                      <div class="clearfix"></div>
                      <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="topnav-dropdown-footer">
            <router-link to="chat">View all Messages</router-link>
          </div>
        </div>
      </li> -->
      <!-- /Message Notifications -->

      <li class="nav-item dropdown has-arrow main-drop">
        <a
          href="javascript:;"
          class="dropdown-toggle nav-link"
          data-bs-toggle="dropdown"
        >
          <span class="user-img me-1 flex-shrink-0">
            <img
              v-if="this.$store?._state?.data?.auth?.user?.profile_picture"
              :src="this.$store?._state?.data?.auth?.user?.profile_picture"
              alt="User Image" />
            <img
              v-else
              src="@/assets/img/profiles/avatar-21.jpg"
              alt="User Image" />
            <span class="status online"></span
          ></span>
          <!-- <span>{{ this.userName }}</span> -->
        </a>
        <div class="dropdown-menu">
          <router-link class="dropdown-item" to="/employee/profile"
            >My Profile</router-link
          >
          <!-- <router-link class="dropdown-item" to="/settings"
            >Settings</router-link
          > -->
          <router-link class="dropdown-item" to="/change-password"
            >Change Password</router-link
          >

          <router-link class="dropdown-item" to="logout" @click="handleLogout"
            >Logout</router-link
          >
        </div>
      </li>
    </ul>
    <!-- /Header Menu -->

    <!-- Mobile Menu -->
    <div class="dropdown mobile-user-menu">
      <a
        href="javascript:;"
        class="nav-link dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        ><i class="fa-solid fa-ellipsis-vertical"></i
      ></a>
      <div class="dropdown-menu dropdown-menu-right">
        <router-link class="dropdown-item" to="/employee/profile"
          >My Profile</router-link
        >
        <router-link class="dropdown-item" to="settings">Settings</router-link>
        <router-link
          class="dropdown-item"
          to="logout"
          @click.prevent="handleLogout"
          >Logout</router-link
        >
      </div>
    </div>
    <!-- /Mobile Menu -->
  </div>
  <!-- /Header -->

  <!-- Warning Alert Modal -->
  <div
    id="warning-alert-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-body p-4">
          <div class="text-center">
            <i
              class="fa-solid text-warning fa-triangle-exclamation"
              style="font-size: 2rem"
            ></i>
            <h4 class="mt-2">Feature Unavailable</h4>
            <p class="mt-3">
              Sorry, your organization currently does not have access to this
              feature. Contact your administrator to learn more about enabling
              this feature.
            </p>
            <b-button variant="warning my-2" data-bs-dismiss="modal">
              Continue
            </b-button>
          </div>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->

  <!-- <sidesettings></sidesettings> -->
</template>

<script>
import AuthService from "@/services/AuthService";
import LogoService from "@/services/LogoService";
import { ref } from "vue";
import { mapGetters } from "vuex";
import clientLogo from "@/assets/img/meri-sehat-logo.svg";
import { removeTawkTo } from "@/utils";
import defaultLogo from '@/assets/img/client-logo.png'
import GlobalSearch from "@/components/GlobalSearch/GlobalSearch.vue";

export default {
  components: { GlobalSearch },
  data() {
    return {
      isGlobalVariant: process.env.VUE_APP_VARIANT === "default",
      isAppedologyVariant: process.env.VUE_APP_VARIANT === "appedology",
      isProGlobalVariant: process.env.VUE_APP_VARIANT === "proglobal",
      miniSidebar: ref(false),
    };
  },
  methods: {
    async handleLogout() {
      this.$store.dispatch("auth/resetState");
      removeTawkTo();
      localStorage.removeItem("token");
      localStorage.removeItem("model-wise-permissions");
      localStorage.removeItem("user");
      sessionStorage.clear();
      this.$router.push("/");
      try {
        await AuthService.logout();
      } catch (error) {
        // this.$store.dispatch("auth/resetState");
        // localStorage.removeItem("token");
        // localStorage.removeItem("model-wise-permissions");
        // this.$router.push("/");
        console.log("error during logout", error);
      }
    },
    toggleSidebar() {
      const body = document.body;
      const contentDiv = body.getElementsByClassName("content")[0];
      body.classList.toggle("mini-sidebar");
      contentDiv.classList.toggle(".mini-sidebar-content");
      this.miniSidebar = !this.miniSidebar;
    },
    toggleSidebar1() {
      const body = document.body;
      body.classList.toggle("slide-nav");
    },
    submitForm() {
      this.$router.push("/search");
    },
    changeThemeColor(primaryColor, secondaryColor) {
      localStorage.setItem("primary-color", primaryColor);
      localStorage.setItem("secondary-color", secondaryColor);
      location.reload();
    },
    updateClientThemeColor() {
      if (this.clientThemeColor) {
        document.documentElement.style.setProperty(
          "--client-theme-color",
          this.clientThemeColor,
        );
      }
    },
  },
  mounted() {
    // // Add scroll event listener
    // window.addEventListener("scroll", () => {
    //   var scroll = window.pageYOffset || document.documentElement.scrollTop;
    //   var header = document.getElementsByClassName("header")[0];

    //   if (scroll < 100) {
    //     header.classList.remove("sticky");
    //   } else {
    //     header.classList.add("sticky");
    //   }
    // });

    this.updateClientThemeColor();

    // Add click event listener
    this.$nextTick(() => {
      document.addEventListener("click", this.handleToggleClick);
    });

    // Add mouseover event listener
    document.addEventListener("mouseover", (event) => {
      event.stopPropagation();

      var body = document.body;
      var toggleBtn = document.getElementById("toggle_btn");
      var sidebar = document.getElementsByClassName("sidebar")[0];
      var subdropUL = document.getElementsByClassName("subdrop");

      if (
        body.classList.contains("mini-sidebar") &&
        toggleBtn.style.display !== "none"
      ) {
        var target = event.target.closest(".sidebar");

        if (target) {
          body.classList.add("expand-menu");
          for (var i = 0; i < subdropUL.length; i++) {
            var ul = subdropUL[i].nextElementSibling;
            if (ul) {
              ul.style.display = "block";
            }
          }
        } else {
          body.classList.remove("expand-menu");
          for (var i = 0; i < subdropUL.length; i++) {
            var ul = subdropUL[i].nextElementSibling;
            if (ul) {
              ul.style.display = "none";
            }
          }
        }

        event.preventDefault();
      }
    });
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleToggleClick);
  },
  computed: {
    ...mapGetters("auth", ["userRole"]),
    ...mapGetters("auth", ["userName"]),
    appVariant() {
      return process.env.VUE_APP_VARIANT || "default";
    },
    logo() {
      return this.$store.getters["system/systemLogo"];
    },
    logoSrc() {
      return this.logo || defaultLogo;
    },
    clientThemeColor() {
      return this.$store.getters["system/primaryColor"];
    },
  },
};
</script>

<style scoped>
.noti-content {
  display: flex;
  justify-content: center;
  border-radius: 0;
  height: 250px;
}
.noti-content:not(:last-child) {
  margin-bottom: 0;
}
.noti-content .notification-list {
  position: absolute;
  top: 0px;
  width: 100%;
}
.chat-block {
  margin: 0;
  display: flex;
  align-items: center;
}
.media-body {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background: #f9f9f9; /* Light background for contrast */
  border: 1px solid #ddd; /* Border to define the rectangle */
  border-radius: 8px; /* Rounded corners */
  padding: 12px; /* Padding for spacing */
  margin-left: 0px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Light shadow for depth */
}

.noti-details {
  font-size: 14px;
  color: #333;
  margin: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.noti-title {
  font-weight: bold;
  color: #333;
}

.noti-time {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}

.notification-time {
  font-style: italic;
}
</style>
